import { mapState } from 'vuex';

import { Errors } from '@/enums/errors.enum';
import { formMixin } from './form';
import { notificationsMixin } from './notifications';
import { tryParseInt } from '@/utils/number';
import { focusMixin } from './focus';

/**
 * Mixin zarządzania modelem
 *
 * @export
 * @param {string} moduleName - nazwa modułu
 * @param {Object} messages - treści notyfikacji
 * @param {string} [messages.formError] - treść notyfikacji o błędzie walidacji
 * @param @deprecated {function} emptyModel - funkcja tworząca pusty model
 * @returns
 */
export function manageMixin(moduleName, messages, emptyModel) {
  return {
    mixins: [formMixin, notificationsMixin, focusMixin('show', true)],
    data() {
      return {
        model: {}
      };
    },
    props: {
      // Boolean kontrolujący widoczność modala
      show: {
        type: Boolean,
        required: true,
        default: false
      },
      // Identyfikator edytowanej encji
      id: {
        type: Number,
        required: false,
        default: undefined
      }
    },
    methods: {
      // @vuese
      // Funkcja mapująca model przed zapisem
      prepareModel(model) {
        return model;
      },
      // @vuese
      // Funkcja emituje event `close` do zamknięcia modalu
      close() {
        // Zamyka modal
        this.$emit('close');
      },
      // @vuese
      // Funkcja waliduje formularz, i zapisuje/nadpisuje dane w bazie
      save() {
        if (!this.$schema.$validateAll().length) {
          const model = this.prepareModel(this.$schema.$getData());
          if (this.id) {
            // Emituje event do edytowania danych
            // @arg Zwalidowany model do edycji w bazie
            this.$emit('update', { id: tryParseInt(this.id), ...model });
          } else {
            // Emituje event do zapisu danych
            // @arg Zwalidowany model do utworzenia w bazie
            this.$emit('save', model);
          }
          this.close();
        } else {
          this.notifyError(messages.formError || Errors.FORM_INCORRECTLY_COMPLETED);
        }
      },

      // @vuese
      // Ustawia dane formularza
      setData() {
        this.$schema.$setDefault();
        if (this.id) {
          this.$schema.$setData(this.stateData, undefined, true);
        }
        this.$schema.$reset();
      }
    },
    computed: mapState({
      stateData: state => state[moduleName].data
    }),
    watch: {
      // @vuese
      // Resetuje pola modala przed pokazaniem go
      show(val) {
        if (val) {
          this.setData();
        }
      }
    }
  };
}
